import React from 'react'
import ReactSelect, { Option, ReactSelectProps } from 'react-select'
import { FieldProps } from 'formik'

const singleValueStyle = {
  singleValue: (styles, { data }) => ({ ...styles, overflow: 'visible' }),
};

const FormikSelectNested: React.SFC<ReactSelectProps & FieldProps> = ({
    options,
    field,
    form,
    label,
    error,
    withHr,
    touched,
    handleBlur,
    onSelectUser
  }) => (
      <div className="form-group">
        <div>
          { label &&
            <label htmlFor="color">{label}</label>
          }
          <ReactSelect
            options={options}
            name={field.name}
            value={options ? options.find(option => option.value.value == field.value.value) : {label:"failed", value:"failed"}}
            onBlur={field.onBlur}
            styles={singleValueStyle}
            onChange={(option: Option) => {
              onSelectUser ? onSelectUser(option.email?option.email:"", option.email_2?","+option.email_2:"") : console.log("");
              form.setFieldValue(field.name, option.value)
            }}
          />
          {!!error &&
            touched && (
              <div style={{ color: 'red', marginTop: '.5rem' }}>{error}</div>
            )}
        </div>
        {withHr && <hr/> }
      </div>
    )

export { FormikSelectNested };
